import styled from "styled-components";

export const StyledSection = styled.div`
  position: relative;
  height: 100vh;

  & img {
    object-fit: cover;
    width: 100vw;
    height: 100vh;
  }
`;

export const StyledHeroImage = styled.img`
  object-fit: cover;
  width: 100vw;
  height: 100vh;
`;
